/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


// Afterpay styles and content manipulation
(function () {
  function applyAfterpayStyles() {
    const placement = document.querySelector('square-placement');
    if (!placement || !placement.shadowRoot) return;

    const shadow = placement.shadowRoot;

    // Prevent duplicate injection
    if (!shadow.querySelector('#afterpay-custom-style')) {
      const style = document.createElement('style');
      style.id = 'afterpay-custom-style';
      style.textContent = `
        .afterpay-paragraph {
          line-height: 1.5;
        }
        .afterpay-paragraph {
          --messaging-font-size: 15.12px;
        }
        .afterpay-logo.brand-afterpay {
          --logo-badge-width: 82px;
          vertical-align: middle;
        }

        @media (max-width: 1000px) {
          .afterpay-main-text {
            display: block;
            line-height: 1;
          }
        }
      `;
      shadow.appendChild(style);
    }

    // Rewrite copy to: "4 x $XX.XX with "
    const text = shadow.querySelector('.afterpay-main-text');
    if (text && !text.dataset.modified) {
      const amount = text.querySelector('strong')?.textContent?.trim();
      if (amount) {
        text.textContent = `4 x ${amount} with `;
        text.dataset.modified = 'true';
      }
    }
  }

  // Initial run
  applyAfterpayStyles();

  // Observe re-renders (Afterpay + Shopify)
  const observer = new MutationObserver(applyAfterpayStyles);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();



// Palo Alto resolves preorder state server-side and re-renders the ATC button HTML on variant changes.
// Observe final button text output and synchronise preorder state + form property atomically.

(function () {
  const observed = new WeakSet();

  function extractEstimatedToShip(textNode) {
    const helper = textNode.querySelector('.button-helper-text');
    if (!helper) return '';

    const text = helper.textContent.replace(/\s+/g, ' ').trim();
    const idx = text.indexOf('Estimated to Ship');
    return idx !== -1 ? text.slice(idx) : '';
  }

  function sync(productForm) {
    const submitButton = productForm.querySelector('[type="submit"]');
    const textNode = submitButton?.querySelector('[data-add-to-cart-text]');
    if (!submitButton || !textNode) return;

    const form = submitButton.closest('form');
    if (!form) return;

    const isInventoryPreorder =
      textNode.querySelector('.button-helper-text') &&
      textNode.textContent.includes('Estimated to Ship');

    // 1. ORIGINAL behaviour (unchanged)
    submitButton.classList.toggle(
      'is_inventory_preorder',
      isInventoryPreorder
    );

    // 2. Property sync (same timing, same truth)
    const existing = form.querySelector(
      'input[name="properties[Pre-order]"]'
    );

    if (isInventoryPreorder) {
      const shipText = extractEstimatedToShip(textNode);
      if (!shipText) return; // guard against mid-render churn

      if (!existing) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Pre-order]';
        input.value = shipText;
        form.appendChild(input);
      } else {
        existing.value = shipText;
      }
    } else {
      existing?.remove();
    }
  }

  function init(productForm) {
    const submitButton = productForm.querySelector('[type="submit"]');
    const textNode = submitButton?.querySelector('[data-add-to-cart-text]');
    if (!submitButton || !textNode) return;
    if (observed.has(textNode)) return;

    const observer = new MutationObserver(() => {
      sync(productForm);
    });

    observer.observe(textNode, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    // initial run
    sync(productForm);

    observed.add(textNode);
  }

  document.querySelectorAll('product-form').forEach(init);
})();





// Pre-order acceptance modal
// turning off
// (function () {

//   let consentGiven = false;

//   function getEstimateFromButton(button) {
//     const helper = button.querySelector('.button-helper-text');
//     if (!helper) return '';

//     const text = helper.textContent.replace(/\s+/g, ' ').trim();

//     const idx = text.indexOf('Estimated to Ship');
//     return idx !== -1 ? text.slice(idx) : '';
//   }

//   function createPopup() {
//     let popup = document.getElementById('preorder-consent-popup');

//     if (!popup) {
//       popup = document.createElement('div');
//       popup.id = 'preorder-consent-popup';
//       popup.style.display = 'none';

//       popup.innerHTML = `
//         <div class="preorder-overlay"></div>
//         <div class="preorder-modal">

//           <button type="button" class="preorder-close" aria-label="Close">&times;</button>

//           <h3>Please Confirm Your Pre-Order</h3>

//           <p class="preorder-message">
//             This item is a pre-order and will not ship immediately.<br>
//             <span class="preorder-estimate"></span>            
//           </p>


//           <p>
//             <label class="preorder-checkbox">
//               <input type="checkbox" id="preorder-consent-check" />
//               <span class="custom-checkbox"></span>
//               <span class="checkbox-text">
//               I understand this is a pre-order item and it will ship on or after the estimated date above, and I agree to the <a href="https://originalfitwear.com/en-au/pages/pre-order" target="_blank" class="preorder-info-link">
//               pre-order terms
//             </a>.
//               </span>
//             </label>
//           </p>

//           <div class="preorder-buttons">

//             <button type="button"
//               class="btn btn--solid btn--small btn--black btn--advanced btn--advanced-width-height btn--bottom preorder-continue"
//               disabled>
//               <hover-button></hover-button>
//               ADD PRE-ORDER TO CART 
//             </button>

//             <button type="button"
//               class="btn btn--outline btn--small btn--black btn--advanced btn--advanced-width-height btn--bottom preorder-decline">
//               <hover-button></hover-button>
//               Cancel
//             </button>

//           </div>

//         </div>
//       `;

//       document.body.appendChild(popup);

//       const overlay = popup.querySelector('.preorder-overlay');
//       const closeBtn = popup.querySelector('.preorder-close');
//       const checkbox = popup.querySelector('#preorder-consent-check');
//       const confirmBtn = popup.querySelector('.preorder-continue');
//       const declineBtn = popup.querySelector('.preorder-decline');

//       checkbox.addEventListener('change', function () {
//         confirmBtn.disabled = !this.checked;
//       });

//       overlay.addEventListener('click', closePopup);
//       closeBtn.addEventListener('click', closePopup);
//       declineBtn.addEventListener('click', closePopup);
//     }

//     return popup;
//   }

//   function closePopup() {
//     const popup = document.getElementById('preorder-consent-popup');
//     if (!popup) return;

//     popup.style.display = 'none';
//     consentGiven = false;
//   }

//   function openPopup(button) {

//     consentGiven = false;

//     const popup = createPopup();
//     if (!popup) return;

//     const checkbox = popup.querySelector('#preorder-consent-check');
//     const confirmBtn = popup.querySelector('.preorder-continue');
//     const estimateTarget = popup.querySelector('.preorder-estimate');

//     checkbox.checked = false;
//     confirmBtn.disabled = true;

//     // 🔥 Grab directly from clicked button
//     const estimateText = getEstimateFromButton(button);
//     estimateTarget.textContent = estimateText || '';

//     popup.style.display = 'flex';

//     confirmBtn.onclick = function () {
//       consentGiven = true;
//       popup.style.display = 'none';
//       button.click();
//     };
//   }

//   document.addEventListener('click', function (e) {

//     const button = e.target.closest('button[type="submit"].is_inventory_preorder');
//     if (!button) return;

//     if (consentGiven) {
//       consentGiven = false;
//       return;
//     }

//     e.preventDefault();
//     e.stopImmediatePropagation();

//     openPopup(button);

//   }, true);

// })();
